export function createPaymentStore() {
    return {
        namespaced: true,

        state: {
            hasPaymentMethodsDisabledDueToPayingBalance: false,

            hasPaymentMethodsDisabledDueToRepeatPaymentRequirement: false,

            /**
             * @type {string|null}
             */
            restrictToPaymentMethodRef: null,

            /**
             * All payment methods that are visible to the user.
             * Each one of these will render a button.
             * This does not necessarily mean that the payment method is enabled - the button may be disabled.
             *
             * @type {PaymentMethod[]}
             */
            visiblePaymentMethods: [],

            /**
             * All payment methods that are selectable by the user.
             * If a payment method is in visiblePaymentMethods but not selectablePaymentMethods its
             * button will be disabled.
             *
             * @type {PaymentMethod[]}
             */
            selectablePaymentMethods: [],

            /**
             * @type {PaymentMethod}
             */
            selectedPaymentMethod: null,

            /**
             * @type {string|null}
             */
            requestRefundOfPaymentInProgress: null,

            /**
             * Is the Payyo WebSocket connected?
             * true = connected, false = disconnected, null = in progress.
             *
             * @type {boolean|null}
             */
            payyoWebSocketConnected: false,
        },

        mutations: {
            setHasPaymentMethodsDisabledDueToPayingBalance(state, value) {
                state.hasPaymentMethodsDisabledDueToPayingBalance = value;
            },

            setHasPaymentMethodsDisabledDueToRepeatPaymentRequirement(state, value) {
                state.hasPaymentMethodsDisabledDueToRepeatPaymentRequirement = value;
            },

            setRestrictToPaymentMethodRef(state, value) {
                state.restrictToPaymentMethodRef = value;
            },

            setSelectedPaymentMethod(state, value) {
                state.selectedPaymentMethod = value;
            },

            setSelectablePaymentMethods(state, value) {
                state.selectablePaymentMethods = value;
            },

            setVisiblePaymentMethods(state, value) {
                state.visiblePaymentMethods = value;
            },

            setRequestRefundOfPaymentInProgress(state, value) {
                state.requestRefundOfPaymentInProgress = value;
            },

            setPayyoWebSocketConnected(state, value) {
                state.payyoWebSocketConnected = value;
            },
        },
    };
}
